// Single source of truth for call-outcome (value, label) pairs, shared by
// CallInterface.js and FrajunWidget.js. Before this, the two widgets stored
// different strings for the same outcome (e.g. FrajunWidget saved
// "Brochure Sent" while CallInterface saved "brochure_sent"), which broke
// outcome-based filtering/reporting across calls logged from either widget.
export const CALL_OUTCOME_OPTIONS = [
  { value: "successful", label: "Successful" },
  { value: "interested", label: "Interested" },
  { value: "brochure_sent", label: "Brochure Sent" },
  { value: "demo_booked", label: "Demo Booked" },
  { value: "not_interested", label: "Not Interested" },
  { value: "missed", label: "Missed" },
  { value: "follow_up_needed", label: "Follow-up Needed" },
  { value: "callback_requested", label: "Call Back / Follow Up" },
  { value: "invalid_number", label: "Invalid Number" },
];

// Calls logged before the shared list existed stored display labels
// ("Not Interested", "Call Back") instead of values.
const LEGACY_OUTCOME_ALIASES = { call_back: "callback_requested" };

export const normalizeCallOutcome = (value) => {
  const key = String(value || "").trim().toLowerCase().replace(/[\s-]+/g, "_");
  return LEGACY_OUTCOME_ALIASES[key] || key;
};

export const getCallOutcomeLabel = (value) =>
  CALL_OUTCOME_OPTIONS.find((o) => o.value === normalizeCallOutcome(value))?.label || value;
